module.exports = __webpack_public_path__ + "static/media/full_3.02fec297.jpg";